export const addPayee = (payeeOption) => {
  if (!payeeOption) {
    return {
      payee: undefined,
      baseDataId: undefined,
      data: undefined,
    }
  }

  const { value, label, data, type } = payeeOption
  return {
    payee: label,
    baseDataId: value,
    data,
    type,
    value: payeeOption,
  }
}
